// extracted by mini-css-extract-plugin
module.exports = {"container":"noResultsBoundary_container__88Iag","related-products":"noResultsBoundary_related-products__QvkNz","relatedProducts":"noResultsBoundary_related-products__QvkNz"};